__turbopack_context__.v({
  "collectionFocus": "GasRoyalties-module-scss-module__kxzIZG__collectionFocus",
  "collectionFocusActive": "GasRoyalties-module-scss-module__kxzIZG__collectionFocusActive",
  "filterDropdown": "GasRoyalties-module-scss-module__kxzIZG__filterDropdown",
  "gasTable": "GasRoyalties-module-scss-module__kxzIZG__gasTable",
  "infoIcon": "GasRoyalties-module-scss-module__kxzIZG__infoIcon",
  "royaltiesTable": "GasRoyalties-module-scss-module__kxzIZG__royaltiesTable",
  "scrollContainer": "GasRoyalties-module-scss-module__kxzIZG__scrollContainer",
});
